import Bar from "../Bar";
import InfoButton from "../buttons/InfoButton";
import SoundButton from "../buttons/SoundButton";
import BankButton from "../buttons/BankButton";
import HomeButton from "../buttons/HomeButton";
import UserButton from "../buttons/UserButton";
import FullscreenButton from "../buttons/FullscreenButton";
import FunPlayLabel from "../labels/FunPlayLabel";
import classes from "../../styles/Bar.module.css";
import iconClasses from "../../styles/Icons.module.css";
import { getClasses } from "../../utils";
import { useAppSelector } from "../../hooks";
import { FREE_MODE_CURRENCY } from "../../commander/Types";

const ControlsBar: React.FC = () => {
  const { currency } = useAppSelector((state) => state.details);

  return (
    <Bar
      className={getClasses(classes, "portrait-buttons-controls align center")}
    >
      <Bar className="align center">
        <div className={getClasses(iconClasses, "icons-container", "small")}>
          <InfoButton />
          <BankButton />
          <HomeButton />
          <UserButton />
        </div>
        <FunPlayLabel visible={currency.code === FREE_MODE_CURRENCY} />

        <div className={getClasses(iconClasses, "icons-container", "small")}>
          <SoundButton />
          <FullscreenButton />
        </div>
      </Bar>
    </Bar>
  );
};

export default ControlsBar;
